import React from "react";
import PropTypes from 'prop-types';
import RenderComponentProto from "../../render-component-proto";

import InputInlineEditable from '../../../../gd-components/input-inline-editable/input-inline-editable';

import Classes from "classnames";

export default class URLField extends RenderComponentProto {

    static props = {
        id: PropTypes.string.isRequired,
        renderMode: PropTypes.oneOf(['list','view','edit','form-new']).isRequired,
        value: PropTypes.any,
        canEdit: PropTypes.bool,
        onChange: PropTypes.func,
        //old
        params: PropTypes.object,
        onFocusCallback: PropTypes.func,
        onBlurCallback: PropTypes.func,
        stateless: PropTypes.bool // ????
    };

    static defaultProps = {
        canEdit: false
    };

    constructor(props) {
        super(props);

        this._bind('onFocus','onBlur','onChange','onOpenClick');

        this.state = {
            isEditing: false,
            value: props.value
        }
    }

    onChange(newValue) {
        if (!newValue) newValue = '';

        const { onChange } = this.props;
        this.setState({value: newValue}, ()=>{
            if (onChange) onChange(newValue)
        });
    }

    onFocus(e) {
        this.setState({isEditing: true}, ()=> {
            if (this.props.onFocus) this.props.onFocus(e)
        });
    }

    onBlur(e) {
        this.setState({isEditing: false}, ()=>{
            if (this.props.onBlur) this.props.onBlur(e);
        });
    }

    onOpenClick(e) {
        e.stopPropagation()

        let url = this.state.value;

        if (url.substring(0,4) !== 'http' && !url.includes('://')) {
            url = 'http://'+url
        }

        gd.openInNewWindow(url)
    }

    render() {

        const classes = Classes('gd-field-url gd-custom-field-input-based',this.props.renderMode,{
            'edit': this.state.isEditing,
            'disabled': this.props.canEdit === false,
            'not-set': !this.state.value
        });

        return (
            <div className={classes}>
                <InputInlineEditable ref="url"
                                     className=""
                                     placeholder=""
                                     value={this.state.value}
                                     disabled={this.props.canEdit === false}
                                     onChange={this.onChange}
                                     onFocus={this.onFocus}
                                     onBlur={this.onBlur}
                                     commitDelay={2000}/>
                <div className="i5-open-new-window" onClick={this.onOpenClick}/>
            </div>
        );
    }
}
